import { FormControlLabel, FormGroup, FormHelperText, Switch, SwitchProps } from '@mui/material'
import { useTranslation } from 'react-i18next'

type DateRangeLimitSwitchProps = SwitchProps & {
  helperText?: string | JSX.Element
}

export default function DateRangeLimitSwitch({ helperText, ...props }: DateRangeLimitSwitchProps) {
  /**
   * The translate function.
   */
  const { t } = useTranslation('common')

  return (
    <FormGroup>
      <FormControlLabel
        control={<Switch {...props} />}
        label={t('showDataOnlyFromAssetDateRange')}
        labelPlacement="end"
        disableTypography
        sx={{ pl: 2 }}
      />
      {helperText && <FormHelperText sx={{ mt: 1 }}>{helperText}</FormHelperText>}
    </FormGroup>
  )
}
